import create from "zustand";

const useUserStore = create((set) => ({
  isListChanged: false,
  refreshUserList: () =>
    set((state) => ({ isListChanged: !state.isListChanged })),
}));

export default useUserStore;
